import {DynamicType, FiltersType, UnitsControlEnum, UnitStatusEnum} from "@context/map/typeMutableStore";
import treeToHashMap from "@context/map/utilMutableStore";
import logger from "@utils/logger";
import LocalStorageService from "@api/local/LocalStorageService"
import {WsChange} from "@api/socket/WebSocketService";
import { actions as UnitSliceActions } from "../../../store/reducers/units";
import { store } from "../../../store";

const httpClient = require('@infobis/api-module').default;


type metaType = {
  status: UnitStatusEnum
  load: boolean
  error: string
  dynamic: DynamicType
  filters: FiltersType
  lastUpdate: any;
}


type subscribeFuncType = (fun: any) => void

export type Lat = number
export type Lon = number
export type Timestamp = number
export type Clear = boolean

export type RawTrackPoint = [Lon, Lat, Timestamp, Clear?]
export type TrackPoint = {
  lon: Lon,
  lat: Lat,
  time: Timestamp,
  clear?: Clear
}
export type RawUnitTrack = RawTrackPoint[]
export type UnitElementDynamic = {
  trackPoints: TrackPoint[],
  azimuth: number
  unitState: string
  track?: RawUnitTrack
  rt_position: any
  position?: [number ,number]
}

export interface HashElement extends Record<string, any>{
}

export interface UnitHashElement extends HashElement {
  dynamic: Partial<UnitElementDynamic>,
  glid: string,
  type: string,
  typeName: string,
  position: any
}

const log = logger.getLogger("unit.store")

class UnitsStore {
  type = UnitsControlEnum.UNITS
  units: any = {}
  unitsType: any = []
  hashUnits: { [key: string]: any } = {}
  filtersStatusUnits: any = []
  
  options: any = {
    zIndex: 20
  }
  
  meta: metaType = {
    status: UnitStatusEnum.NO_TOUCH,
    load: false,
    error: "",
    dynamic: [],
    filters: [],
    lastUpdate: new Date().getTime()
  }
  
  doSubscribe: subscribeFuncType = (a: any) => ""
  
  constructor() {
    //@ts-ignore
    window.UnitService = this
    
    this.setLastUpdate = this.setLastUpdate.bind(this)
    this.reduce = this.reduce.bind(this)
    this.reduce = this.reduce.bind(this)
    this.fetchDynamicDataUnits = this.fetchDynamicDataUnits.bind(this)
    this.setFilters = this.setFilters.bind(this)
  }
  
  public async init() {
    log.debug("Initializing unit service")
    await this.fetchUnits()
    await this.fetchUnitsType()
    
    let status = LocalStorageService.getFieldsTypeFilters()
    return !status
      ? this.fetchUnitsStatus()
      : this.reduce(UnitsControlEnum.STATUS, status)
  }
  
  subscribe(func: any) {
    this.doSubscribe = func
  }
  
  setLastUpdate = () => {
    this.meta.lastUpdate = new Date().getTime();
    this.doSubscribe({...this.meta})
  }
  
  // getUnitTrackPath(hashElement: UnitHashElement, change: WsChange): TrackPoint[] {
  //   delete hashElement.dynamic.track
  //   // TODO! Пока нет времени плеера, ограничиваем след от движения последними 100 точками
  //   const maxTrackPoints = 100
  //   const currTrack: TrackPoint[] = change.values.track.map(([lon, lat, time, clear]: [Lon, Lat, Timestamp, Clear?]) =>
  //     ({
  //       lon,
  //       lat,
  //       time,
  //       clear
  //     } as TrackPoint)
  //   )
  //
  //   const points: TrackPoint[] = (hashElement.dynamic.trackPoints || [])
  //     .concat(currTrack)
  //     .reduce((points: TrackPoint[], point: TrackPoint) =>
  //       point.clear ? [point] : points.concat(point), [] as TrackPoint[]);
  //
  //   const dropIndex = points.length - maxTrackPoints
  //   if (dropIndex > 0) points.splice(0, dropIndex)
  //
  //   return points
  // }getUnitTrackPath(hashElement: UnitHashElement, change: WsChange): TrackPoint[] {
  //   delete hashElement.dynamic.track
  //   // TODO! Пока нет времени плеера, ограничиваем след от движения последними 100 точками
  //   const maxTrackPoints = 100
  //   const currTrack: TrackPoint[] = change.values.track.map(([lon, lat, time, clear]: [Lon, Lat, Timestamp, Clear?]) =>
  //     ({
  //       lon,
  //       lat,
  //       time,
  //       clear
  //     } as TrackPoint)
  //   )
  //
  //   const points: TrackPoint[] = (hashElement.dynamic.trackPoints || [])
  //     .concat(currTrack)
  //     .reduce((points: TrackPoint[], point: TrackPoint) =>
  //       point.clear ? [point] : points.concat(point), [] as TrackPoint[]);
  //
  //   const dropIndex = points.length - maxTrackPoints
  //   if (dropIndex > 0) points.splice(0, dropIndex)
  //
  //   return points
  // }
  
  processChange(change: WsChange) {
    let hashElement: UnitHashElement = this.hashUnits[change.id]
    this.meta.dynamic.push(change.id)
    if (hashElement) {
      hashElement.dynamic = {
        ...hashElement.dynamic,
        ...change.values,
        position:
          change?.values?.rt_position ||
          change?.values?.position ||
          hashElement?.dynamic?.position ||
          []
      }
      delete hashElement?.dynamic?.rt_position
      if (change.values.track) {
        // hashElement.dynamic.trackPoints = this.getUnitTrackPath(hashElement, change)
      }
    } else {
      if(log.isDebugEnabled())
        log.warn("Got websocket data for source id " + change.id + ", but the object is not present in entity map")
    }
  }
  
  reduce(type: UnitsControlEnum, changes: WsChange[]) {
    switch (type) {
      case UnitsControlEnum.UNITS:
        this.units = changes;
        this.hashUnits = treeToHashMap(changes);
        this.changeStatus(UnitStatusEnum.GET_UNITS)
        break;
      case UnitsControlEnum.TYPE:
        this.unitsType = changes
        break;
      case UnitsControlEnum.DYNAMIC:
        store.dispatch(UnitSliceActions.applyWsChange({ changes }))
        // data.forEach((c) => this.processChange(c));
        // this.changeStatus(UnitStatusEnum.GET_DYNAMIC)
        break;
      case UnitsControlEnum.STATUS:
        this.filtersStatusUnits = changes
        LocalStorageService.setUnitsStatusFilters(changes)
        break;
    }
    this.setLastUpdate();
  }
  
  changeStatus(type: UnitStatusEnum) {
    this.meta = {
      ...this.meta,
      status: type
    }
  }
  
  fetchDynamicDataUnits(data: any) {
    this.reduce(UnitsControlEnum.DYNAMIC, data)
  }
  
  setFilters(props: any) {
    let {value, action} = props
    
    switch (action) {
      case "ADD": {
        this.meta.filters.push(value)
        break;
      }
      case "REMOVE": {
        this.meta.filters.splice(value)
        break;
      }
    }
    this.changeStatus(UnitStatusEnum.SET_FILTERS)
  }
  
  //=============================================>
  async fetchUnits() {
    try {
      this.meta.load = true
      let result = await httpClient.makeRequest({
        url: `/unitTree?sort=%5B%7B%22property%22%3A%22leaf%22%2C%22direction%22%3A%22ASC%22%7D%5D&node=`,
        params: {
          method: 'GET',
        },
        authorize: true
      })
      this.reduce(UnitsControlEnum.UNITS, result);
    } catch (e) {
      this.meta.error = JSON.stringify(`UNITS: ${e}`);
    } finally {
      this.meta.load = false
    }
  }
  
  async fetchUnitsType() {
    try {
      this.meta.load = true
      let result = await httpClient.makeRequest({
        url: `/unitFilterItems?_dc=1650031185269&page=1&start=0&limit=25`,
        params: {
          method: 'GET',
        },
        authorize: true
      })
      this.reduce(UnitsControlEnum.TYPE, result);
    } catch (e) {
      this.meta.error = JSON.stringify(`TYPE: ${e}`);
    } finally {
      this.meta.load = false
    }
  }
  
  async fetchUnitsStatus() {
    try {
      this.meta.load = true
      let result = await httpClient.makeRequest({
        url: `/unitStateFilterItems?_dc=1650031185271&page=1&start=0&limit=25`,
        params: {
          method: 'GET',
        },
        authorize: true
      })
      this.reduce(UnitsControlEnum.STATUS, result);
    } catch (e) {
      this.meta.error = JSON.stringify(`TYPE: ${e}`);
    } finally {
      this.meta.load = false
    }
  }
}

export default new UnitsStore();